import React from "react";
import { TRUST_METRICS } from "../data/mock";
import { useTranslation } from "react-i18next";

export const TrustBar = () => {
  const { t } = useTranslation();
  return (
    <section className="relative -mt-8 z-20 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section label */}
        <p className="text-center text-sm text-[#7A7A8A] font-medium tracking-wide uppercase mb-6">
          {t("trustBar.label")}
        </p>

        {/* Metrics Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {TRUST_METRICS.map((metric, index) => {
            const Icon = metric.icon;
            return (
              <div
                key={metric.label}
                className="group bg-white rounded-2xl p-6 sm:p-8 border border-[#E8E4DC]/80 hover-lift text-center section-reveal"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-[#F5F1EA] flex items-center justify-center mx-auto mb-4 group-hover:bg-[#0C2340] transition-colors duration-300">
                  <Icon className="w-5 h-5 text-[#C8A24D] group-hover:text-[#E8D5A0] transition-colors duration-300" />
                </div>
                <div className="text-2xl sm:text-3xl font-bold text-[#0C2340] mb-1" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  {metric.value}
                </div>
                <div className="text-sm text-[#7A7A8A] font-medium">{t(`trustBar.metric${index + 1}`)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
